import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

const getSlotStyle = (hasField) => ({
  minHeight: "48px",
  border: hasField ? "1px solid #e0e0e0" : "1px dashed #ccc",
  borderRadius: "4px",
  backgroundColor: hasField ? "white" : "#fafafa",
  display: "flex",
  alignItems: "center",
  padding: "8px 12px",
  marginBottom: "8px",
});

const getFieldStyle = () => ({
  backgroundColor: "white",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  padding: "8px 12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

const PositionSlot = ({ 
  position, 
  label, 
  field, 
  onRemove, 
  onAddClick, 
  availableFields 
}) => {
  const hasField = field && field[0];
  const canAddField = availableFields && availableFields.length > 0;

  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: "text.secondary" }}>
        {label}
      </Typography>

      <Box style={getSlotStyle(hasField)}>
        {hasField ? (
          <Box style={getFieldStyle()}>
            <Typography variant="body2" sx={{ flex: 1 }}>
              {field[2]}
            </Typography>
            <IconButton
              size="small"
              onClick={() => onRemove(position)}
              sx={{ ml: 1 }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            width: "100%",
            color: "text.secondary"
          }}>
            {canAddField ? (
              <IconButton
                size="small"
                onClick={() => onAddClick(position)}
                sx={{ 
                  color: "primary.main",
                  "&:hover": {
                    backgroundColor: "primary.light",
                    color: "primary.contrastText"
                  }
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            ) : (
              <Typography variant="body2" color="text.disabled">
                No field selected
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PositionSlot;
